<p-toast></p-toast>
<p-dialog [(visible)]="documentVersionDatesModalDisplay" [style]="{width: '30vw'}" (onHide)="reloadDocumentVersionDatesModal()" [modal]="true" >
    <ng-template pTemplate="header" let-data="dataVar">
       <b> Document Version Dates</b>
    </ng-template>
    <div *ngIf="errorMessages.length > 0">
        <p-messages severity="error">
          <ng-template pTemplate>
            <span class="p-message-icon pi pi-times-circle"></span>
            <span class="p-ml-2"
              >Please correct the following errors</span
            >
            <ul>
              <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
            </ul>
          </ng-template>
        </p-messages>
      </div>
        <div class="col" *ngIf="isDisplayRequestedEffectiveDateControl">
            <app-label labelText= "{{'Requested Effective Date'}}"></app-label>
            <p class="valueStyle"> <b> {{docRequestedEffectiveDate| date:'dd-MMM-yyyy'}} </b> </p>
        </div>

        <div class="col">
          <bpt-datetime
            appendTo="'body'"
            id="effectiveDateId"
            [minDate]="minDateValue.toString()"
            placeholder="Enter or select a date"
            label="Effective Date"
            [(ngModel)]="effectiveDate"
          ></bpt-datetime>
        </div>
            <br>

            <div class="col" *ngIf="displayPeriodicReviewDate">
                <bpt-datetime
                  appendTo="'body'"
                  id="periodicReviewDate"
                  [minDate]="effectiveDate.toString()"
                  placeholder="Enter or select a date"
                  label="Periodic Review Date"
                  [(ngModel)]="periodicReviewDate"
                ></bpt-datetime>
            </div>
    <ng-template pTemplate="footer">
        <p-button appPreventDoubleClick label="Confirm" type="submit" id="confirmButton"  class="align-right" (debounceClick)="confirmClick()" >
        </p-button>
        <p-button appPreventDoubleClick label="Cancel" styleClass="p-button-outlined" type="submit" id="confirmationCancelButton" (debounceClick)="cancelClick()" class="align-right" >
        </p-button>
    </ng-template>
</p-dialog>

<p-dialog
  [(visible)]="showEsignatureConfirmationDialog"
  [style]="{ width: '30vw' }"
  (onHide)="closeConfirmationModal()"
  [modal]="true"
>
  <ng-template pTemplate="header">
    <span class="font-semibold text-xl">Confirmation</span>
  </ng-template>
  <div>
    <em class="pi pi-exclamation-triangle mr-2 font-semibold"></em>
    <span>{{ confirmationMessage }}</span>
  </div>
  <ng-template pTemplate="footer">
    <p-button
    appPreventDoubleClick
      label="No"
      type="submit"
      icon="pi pi-times"
      id="closeEsignature"
      styleClass="p-button-outlined"
      class="align-right"
      (debounceClick)="closeConfirmationModal()"
    >
    </p-button>
    <p-button
    appPreventDoubleClick
      label="Yes"
      icon="pi pi-check"
      type="submit"
      id="saveEsignature"
      class="align-right"
      (debounceClick)="onConfirm()"
    >
    </p-button>
    
  </ng-template>
</p-dialog>
